import { normalizeError } from '@/helpers';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AgenciesApi } from '../../../services';
export const fetchAgenciesAsync = createAsyncThunk('agencies/fetchAgencies', async (_, { rejectWithValue }) => {
    try {
        const agencies = await AgenciesApi.fetchAgencies({
            params: {
                $paging: false,
                $limit: 100,
            },
        });
        return agencies.data;
    }
    catch (error) {
        const normalized = normalizeError(error, 'fetching agencies');
        return rejectWithValue(normalized);
    }
});
export const fetchAgenciesAsyncBuilder = (builder) => {
    builder.addCase(fetchAgenciesAsync.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = '';
    });
    builder.addCase(fetchAgenciesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
    });
    builder.addCase(fetchAgenciesAsync.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
    });
};
